import { IWsMatch } from '@/app/core/websocket/models';
import { FsApiService } from '@/app/services/auth/fs-api.service';
import { FavoritesService } from '@/app/services/favorite';
import { computed, inject, Injectable, signal } from '@angular/core';
import { isSameDay } from 'date-fns';
import { catchError, map, of } from 'rxjs';
import { CompetitionApi } from '../../home/models';
import {
  CompetitionGroupByDate,
  IPaginationTeamCompetitionMatches,
  ITeamCompetitionMatchesApi,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class TeamMatchesActiveService {
  private fsApi = inject(FsApiService);
  private favoritesService = inject(FavoritesService);

  isLoadingTeamsMatchActiveFavorites = signal<boolean>(false);
  isErrorTeamsMatchActiveFavorites = signal<boolean>(false);
  teamsMatchPagination = signal<IPaginationTeamCompetitionMatches | null>(null);
  teamsMatchActive = signal<CompetitionGroupByDate[] | null>(null);

  wsMatchesData = signal<Record<string, IWsMatch>>({});

  paginationMatches = signal<number>(0);
  totoalPageMatches = signal<number>(1);

  isMoreMatches = computed(
    () => this.paginationMatches() < this.totoalPageMatches()
  );

  constructor() {}

  getTeamMatchesActive(teamId: string, page: number = 1) {
    this.isLoadingTeamsMatchActiveFavorites.set(true);
    if (page == 1) this.teamsMatchActive.set([]);

    this.fsApi
      .get<ITeamCompetitionMatchesApi>(`/teams/${teamId}/matches/active`, {
        params: { page, size: 10 },
      })
      .pipe(
        map((data) => {
          const { Competitions, ...rest } = data as ITeamCompetitionMatchesApi;

          // si no hay competiciones
          if (!Competitions) {
            return { ...rest, CompetitionsByDate: [] };
          }

          // mapeo normal de favoritos
          const competitions = Competitions.map((item) => {
            this.favoritesService.checkFavoriteCompetition(
              item.Id,
              item.IsFavorite
            );
            return {
              ...item,
              Matches: item.Matches.map((match) => {
                this.favoritesService.checkFavoriteMatch(
                  match.Id,
                  match.IsFavorite
                );
                return match;
              }),
            };
          });

          // agrupamos por fecha
          const CompetitionsByDate = this.groupCompetitionsByDate(competitions);

          return {
            ...rest,
            CompetitionsByDate,
          };
        }),
        // map((data) => {
        //   const { Competitions, ...rest } = data as ITeamCompetitionMatchesApi;
        //   return {
        //     ...rest,
        //     Competitions:
        //       Competitions === null
        //         ? []
        //         : Competitions.map((item) => {
        //             // add favorite local
        //             this.favoritesService.checkFavoriteCompetition(
        //               item.Id,
        //               item.IsFavorite
        //             );
        //             return {
        //               ...item,
        //               Matches: item.Matches.map((match) => {
        //                 this.favoritesService.checkFavoriteMatch(
        //                   match.Id,
        //                   match.IsFavorite
        //                 );
        //                 return match;
        //               }),
        //             };
        //           }),
        //   };
        // }),
        catchError((err) => {
          console.error(err);
          this.isErrorTeamsMatchActiveFavorites.set(true);
          this.isLoadingTeamsMatchActiveFavorites.set(false);
          return of(null);
        })
      )
      .subscribe((data) => {
        if (!data) {
          this.isLoadingTeamsMatchActiveFavorites.set(false);

          // this.teamsMatchActive.set(null);
          return;
        }
        const { CompetitionsByDate, ...rest } = data;

        if (CompetitionsByDate !== null) {
          this.teamsMatchActive.update((prev) => [
            ...prev!,
            ...CompetitionsByDate,
          ]);
        } else {
          this.teamsMatchActive.set([]);
        }

        this.paginationMatches.set(rest.Page);
        this.totoalPageMatches.set(rest.TotalPages);

        this.teamsMatchPagination.set({ ...rest });
        this.isLoadingTeamsMatchActiveFavorites.set(false);
      });
  }

  private groupCompetitionsByDate(
    competitions: CompetitionApi[]
  ): CompetitionGroupByDate[] {
    const result: CompetitionGroupByDate[] = [];

    competitions.forEach((competition) => {
      competition.Matches.forEach((match) => {
        let dateGroup = result.find((g) => isSameDay(g.date, match.Date));
        if (!dateGroup) {
          dateGroup = { date: match.Date, competitions: [] };
          result.push(dateGroup);
        }

        let comp = dateGroup.competitions.find((c) => c.Id === competition.Id);
        if (!comp) {
          comp = { ...competition, Matches: [] };
          dateGroup.competitions.push(comp);
        }

        comp.Matches.push(match);
      });
    });

    // result.sort((a, b) => a.date.getTime() - b.date.getTime());
    return result;
  }
}
